module.exports = __webpack_public_path__ + "static/media/review.9d173240.png";